import styled from 'styled-components';
import { darken } from 'polished';

export const Container = styled.div<{ $disabled?: boolean }>`
  padding: 0.375rem 0.75rem;
  border: none;
  border-radius: 0.375rem;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};

  &:hover {
    background-color: ${({ $disabled }) =>
      $disabled ? '#ffffff' : darken(0.045, '#ffffff')};
  }

  svg {
    width: 18px;
  }
`;
